import { createStyles, Theme } from '@material-ui/core'
import { textShadowLogoOnDarkHero, transition } from '../../../shared/style-settings'
import { makeStyles } from '@material-ui/core/styles'

export const useAppHeaderRightMenuStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      lineHeight: 0,
      marginLeft: 'auto',
      display: 'flex',
      flexWrap: 'nowrap',
    },

    link: {
      color: theme.palette.common.white,
      textDecoration: 'none',
      margin: '0 7px',
      display: 'inline-flex',
      alignItems: 'center',
      fontSize: 14,
      fontWeight: 600,
      transition: transition,
      cursor: 'pointer',
      marginRight: 0,

      '&:hover': {
        textShadow: textShadowLogoOnDarkHero,
      },

      '& > svg': {
        marginRight: theme.spacing(0.75),
      },

      [theme.breakpoints.down('md')]: {
        fontSize: 14,
        margin: '0 6px',

        '& > svg': {
          transform: 'scale(.9)',
          marginRight: theme.spacing(0.5),
        },
      },
    },

    hideForMobile: {
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },

    accountName: {
      maxWidth: 100,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      display: 'block',
      whiteSpace: 'nowrap',
      lineHeight: '1em',
      marginLeft: theme.spacing(1),
    },
    loginBtnWrapper: {
      minWidth: '150px',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    userAvatar: {
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
  })
)
